import classNames from 'classnames';
import React, { use, useReducer } from 'react';

import AnimatedExpandWrapper from 'src/components/common/animated-expand-wrapper';
import Globe from 'src/components/icons/globe';
import RedesignDownChevronThin from 'src/components/icons/redesign-down-chevron-thin';
import { getFooterColors } from 'src/components/layout/footer/colors';
import { SiteContext } from 'src/context/site-context';

import * as styles from './country-selection.module.scss';

type CountrySelectionProps = {
  currentCountryText: string;
  links: readonly Queries.FooterLink[];
};

const CountrySelection = ({ currentCountryText, links }: CountrySelectionProps) => {
  const { styling, buildType } = use(SiteContext);

  const [isOpen, toggleOpen] = useReducer((isOpen) => !isOpen, false);

  const footerColors = getFooterColors(styling, buildType);

  return (
    <div>
      <button type="button" className={styles.button} onClick={toggleOpen}>
        <Globe fill={footerColors.heading} />
        <div className={styles.countryText}>{currentCountryText}</div>
        <div className={classNames(styles.chevron, isOpen && styles.open)}>
          <div className={styles.desktopChevronIcon}>
            <RedesignDownChevronThin size="0.875rem" fill={footerColors.text} />
          </div>
          <div className={styles.mobileChevronIcon}>
            <RedesignDownChevronThin size="1.25rem" fill={footerColors.text} />
          </div>
        </div>
      </button>
      <AnimatedExpandWrapper
        isExpanded={isOpen}
        className={classNames(isOpen && styles.expandedContainer)}
      >
        <div className={styles.linksWrapper}>
          {links.map(({ text, url, openInNewTab }) => (
            <div key={text} className={styles.link}>
              <a
                href={url!}
                target={openInNewTab === true ? '_blank' : undefined}
                rel={openInNewTab === true ? 'noopener noreferrer' : undefined}
              >
                {text}
              </a>
            </div>
          ))}
        </div>
      </AnimatedExpandWrapper>
    </div>
  );
};

export default CountrySelection;
